module.exports = __webpack_public_path__ + "static/media/daily-ui.8bbf8665.png";